import { breakpoints, IconRegularClose, theme } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const ModalCloseButton = styled(IconRegularClose)`
  cursor: pointer;

  width: 1.25rem;
  height: 1.25rem;

  color: ${theme.color.icon.primary};
`;

export const ModalTitleWrapper = styled.div`
  ${theme.typography.titleLarge};
`;

export const modalHeaderWrapperClass = css`
  display: none;

  @media (min-width: ${breakpoints.md}) {
    display: block;
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
  }
`;

export const modalHeaderWrapperNewDesignClass = css`
  display: none;

  @media (min-width: ${breakpoints.md}) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 0;
  }
`;
